module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("我是部门管理")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-844fa3d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/Department.vue
// module id = 603
// module chunks = 2